import { Injectable } from '@angular/core';

import { AuthService } from '../../../core';
import { Usuario } from '../../usuario';
import { usuarioPerfis } from '../../usuario/usuario-perfil';
import { Recurso } from '../recurso';

/** Acessos permitidos à cada recurso */
import { acessosClienteCarteira } from '../../cliente-carteira/carteiras/cliente-carteira/can-activate-cliente-carteira';
import { acessosProspectCarteira } from '../../cliente-carteira/carteiras/prospect-carteira/can-activate-prospect-carteira';
import { acessosClienteGrupoEconomico } from '../../cliente-grupo-economico/can-activate-cliente-grupo-economico';
import { acessosDashboard } from '../../dashboard/can-activate-dashboard';
import { acessosItem } from '../../item/can-activate-item';
import { acessosPedido } from '../../pedido/can-ativate-pedido';
import { acessosCliente } from '../../pessoa/cliente/can-activate-cliente';
import { CLIENTES_PATH_ROUTE } from '../../pessoa/cliente/routes';
import { acessosRepresentante } from '../../pessoa/representante/can-activate-representante';
import { acessosTransportadora } from '../../pessoa/transportadora/can-activate-transportadora';
import { acessosRegiao } from '../../regiao/can-activate-regiao';
import { acessosListagemTabelaPreco } from '../../../domains/preparation/tabelas-precos/guards/can-activate-tabelas-precos-listagem.guard';
// import { acessosMetaLinha } from '../../meta-linha/can-activate-meta-linha';
import { acessosMeta } from '../../meta/can-activate-meta';
import { acessosTituloReceber } from '../../titulo-receber/can-activate-titulo-receber';
// import { acessosIndicador } from '../../indicador/can-activate-indicador';
import { acessosCurvaAbcVenda } from '../../consultas/curva-abc-venda/can-activate-curva-abc-venda';
import { acessosEfetividadeVenda } from '../../consultas/efetividade-venda/can-activate-efetividade-venda';
// import { acessosPeriodicidadeInativa } from '../../periodicidade-inativa/can-activate-periodicidade-inativa';
// import { acessosClientesSemAtendimento } from '../../consultas/clientes-sem-atendimento/can-activate-clientes-sem-atendimento';
import { acessosMetaFaturamento } from '../../consultas/meta-faturamento/can-activate-meta-faturamento';
import { acessosPedidoGep } from '../../consultas/pedido-gep/can-activate-pedido-gep';
import { acessosPedidoStatus } from '../../consultas/pedido-status/can-activate-pedido-status';
// import { acessosMetaEstado } from '../../meta-estado/can-activate-meta-estado';

import { acessosNotaFiscal } from '../../../domains/execution/notas-fiscais/guards/can-activate-notas-fiscais.guard';
import { acessosAnaliseSellIn } from '../../analise-sellin/can-activate-analise-sellin';
import { acessosAtividade } from '../../atividade/can-activate-atividade';
import { acessosColeta } from '../../coleta/can-activate-coleta';
import { acessosAnaliseFinanceira } from '../../consultas/analise-financeira/can-activate-analise-financeira';
import { getAcessosCotacao } from '../../cotacao/can-activate-cotacao';
import { acessosExpedicao } from '../../expedicao/can-activate-expedicao';
import { acessosItemUnidade } from '../../item-unidade/can-activate-item-unidade';
// import { acessosMetaProjecaoMercadoReport } from '../../reports/meta-projecao-mercado/can-activate-meta-projecao-mercado-report';
import { acessosCarteiraPedido } from '../../carteira-pedido/can-activate-carteira-pedido';
import { acessosComissao } from '../../comissao/can-activate-comissao';
import { acessosAnaliseRepresentante } from '../../consultas/analise-representante/can-activate-analise-representante';
import { acessosBonificacaoCliente } from '../../consultas/bonificacao-cliente/can-activate-bonificacao-cliente';
import { acessosBonificacao } from '../../consultas/bonificacao/can-activate-bonificacao';
import { acessosCotacaoPerdidaItem } from '../../consultas/cotacao-perdida-item/can-activate-cotacao-perdida-item';
import { acessosCotacaoPerdida } from '../../consultas/cotacao-perdida/can-activate-cotacao-perdida';
import { acessosCotacaoPrazoEntrega } from '../../consultas/cotacao-prazo-entrega/can-activate-cotacao-prazo-entrega';
import { acessosCotacaoStatus } from '../../consultas/cotacao-status/can-activate-cotacao-status';
import { acessosMinhaRegiao } from '../../consultas/minha-regiao/can-activate-minha-regiao';
import { acessosPedidoResultadoLiquido } from '../../consultas/pedido-resultado-liquido/can-activate-pedido-resultado-liquido';


import { acessosProspeccaoOutbound } from '../../prospeccao-outbound/can-activate-prospeccao-outbound';
import { acessosRafitecMeta } from '../../rafitec/consultas/meta/can-activate-rafitec-meta';
import { acessosTituloReceberAdimplenciaConsulta } from '../../titulo-receber/adimplencia/consulta/can-activate-titulo-receber-adimplencia-consulta';

// Arquivos

// CAMPANHAS
import { getAcessosCampanhas } from '../../campanhas/campanhas/can-activate-campanha';

// CRM
import { acessosLead } from '../../crm/lead/can-activate-lead';
import { acessosNegocio } from '../../crm/negocio/can-activate-negocio';

// KPIs
import { acessosAnaliseMercado } from 'app/core/guards/customer/analise-mercado.guard';
import { acessosMatrizPic } from 'app/core/guards/customer/matriz-pic.guard';
import { canAccessAIPage } from '../../../domains/aya/guards/can-access-page.guard';
import { admin } from '../../../domains/core/settings/only-admin.guard';
import { acessosRelatorios } from '../../../domains/relatorios/permissoes/permissoes';
import { ISidebarMenuItem } from '../../../shell/sidebar-menu/interfaces/sidebar-menu-item.interface';
import { acessosKPICrossSell } from '../../kpis/cross-sell/can-activate-kpi-cross-sell';
import { CROSS_SELL_KPIS_PATH_ROUTE } from '../../kpis/cross-sell/routes';
import {
  PRODUTIVIDADE_KPIS_ACESSOS,
  PRODUTIVIDADE_KPIS_PATH_ROUTE
} from '../../kpis/produtividade/routes';
import { KPIS_PATH_ROUTE } from '../../kpis/routes';

@Injectable({
  providedIn: 'root'
})
export class RecursoService {
  constructor(private authService: AuthService) {}

  /** Recursos do sistema */
  private get recursos(): Recurso[] {
    return [
      {
        nome: 'AyA',
        path: '/ceppem-ai',
        icone: 'fas fa-star',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessoRestrito: 'acessoAI',
        acessos: canAccessAIPage
      },
      {
        nome: 'Dashboard',
        path: '/dashboard',
        icone: 'fas fa-tachometer-alt',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: acessosDashboard
      },
      {
        nome: 'KPIs',
        icone: 'fas fa-chart-line',
        subItens: [
          {
            nome: 'Cross Sell',
            path: `/${KPIS_PATH_ROUTE}/${CROSS_SELL_KPIS_PATH_ROUTE}`,
            icone: 'fas fa-chart-line',
            acessoNutrata: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessos: acessosKPICrossSell
          },
          {
            nome: 'Produtividade',
            path: `/${KPIS_PATH_ROUTE}/${PRODUTIVIDADE_KPIS_PATH_ROUTE}`,
            icone: 'fas fa-chart-line',
            acessoNutrata: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessos: PRODUTIVIDADE_KPIS_ACESSOS
          }
        ],
        acessoNutrata: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true
      },
      {
        nome: 'Atividades',
        path: '/atividades',
        icone: 'far fa-check-square',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: acessosAtividade
      },
      {
        nome: 'Análise Sell In',
        path: '/analise-sellin',
        icone: 'fas fa-chart-pie',
        acessos: acessosAnaliseSellIn,
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: false,
        acessoAcaiAmazonas: true,
        acessoPropex: false
      },
      {
        nome: 'Análise de Market Share',
        path: '/analises-market-share',
        icone: 'fas fa-chart-pie',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: usuarioPerfis
      },
      {
        nome: 'Prospecção Outbound',
        path: '/prospeccao-outbound',
        icone: 'fab fa-searchengin',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessoRestrito: 'acessoProspeccaoOutbound',
        acessos: acessosProspeccaoOutbound
      },
      {
        nome: 'Leads',
        path: '/leads',
        icone: 'fas fa-bullseye',
        acessoNutrata: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessos: acessosLead
      },
      {
        nome: 'Clientes',
        icone: 'far fa-user-circle',
        subItens: [
          {
            nome: 'Cadastro',
            path: `/${CLIENTES_PATH_ROUTE}/cadastro`,
            icone: 'far fa-user-circle',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosCliente
          },
          {
            nome: 'Carteira de Prospects',
            path: `/${CLIENTES_PATH_ROUTE}/carteira-prospects`,
            icone: 'far fa-user-circle',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosProspectCarteira
          },
          {
            nome: 'Carteira de Clientes',
            path: `/${CLIENTES_PATH_ROUTE}/carteira-clientes`,
            icone: 'far fa-user-circle',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosClienteCarteira
          },
          {
            nome: 'Rap 3D',
            path: `/${CLIENTES_PATH_ROUTE}/rap-3d`,
            icone: 'fas fa-layer-group',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: false,
            acessoAcaiAmazonas: true,
            acessoPropex: false,
            acessos: acessosAnaliseMercado
          },
          {
            // OLD
            nome: 'Análises de Mercado',
            path: `/${CLIENTES_PATH_ROUTE}/analise-mercado-v1`,
            icone: 'far fa-user-circle',
            acessoNutrata: false,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessoAgroplas: false,
            acessoRafitecGrass: false,
            acessos: acessosAnaliseMercado
          },
          {
            nome: 'Matriz PIC',
            path: `/${CLIENTES_PATH_ROUTE}/matriz-pic`,
            icone: 'far fa-user-circle',
            acessoNutrata: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessos: acessosMatrizPic
          },
          {
            nome: 'Grupos Econômicos',
            path: `/${CLIENTES_PATH_ROUTE}/grupos-economicos`,
            icone: 'far fa-user-circle',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosClienteGrupoEconomico
          }
        ],
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true
      },
      {
        nome: 'Itens',
        icone: 'fas fa-th',
        subItens: [
          {
            nome: 'Cadastro',
            path: '/itens',
            icone: 'fas fa-th',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosItem
          },
          {
            nome: 'PLM 3Vs',
            path: '/plm/faseamento',
            rotasAtivas: ['/plm/produtos'],
            icone: 'fas fa-layer-group',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: usuarioPerfis
          },
          {
            nome: 'Governança',
            path: '/plm/governanca',
            icone: 'fas fa-award',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoRestrito: [
              'podeAcompanharGatesPLM',
              'podeDecidirGatesPLM',
              'podeEncerrarProdutoPLM'
            ],
            acessos: usuarioPerfis
          },
          {
            nome: 'Classificações PLM',
            path: '/classificacoes-plm',
            icone: 'fas fa-list-ul',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: admin
          },
          {
            nome: 'Unidades',
            path: '/itens-unidades',
            icone: 'fas fa-th',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosItemUnidade
          }
        ],
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true
      },
      {
        nome: 'Campanhas',
        path: '/campanhas',
        icone: 'fas fa-bullhorn',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: getAcessosCampanhas(this.authService)
      },
      {
        nome: 'Cotações',
        path: '/cotacoes',
        icone: 'fas fa-money-check-alt',
        acessoNutrata: false,
        acessoRafitec: true,
        acessoAcaiAmazonas: false,
        acessoPropex: true,
        acessoAgroplas: false,
        acessoRafitecGrass: false,
        acessos: getAcessosCotacao(this.authService)
      },
      {
        nome: 'Negócios',
        path: '/negocios',
        icone: 'fas fa-bullseye',
        acessoNutrata: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessos: acessosNegocio
      },
      {
        nome: 'Pedidos',
        path: '/pedidos',
        icone: 'fas fa-file-invoice-dollar',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: acessosPedido
      },
      {
        nome: 'Expedição',
        path: '/expedicao',
        icone: 'fas fa-cubes',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: false,
        acessoAcaiAmazonas: true,
        acessoPropex: false,
        acessos: acessosExpedicao
      },
      {
        nome: 'Coleta',
        path: '/coleta',
        icone: 'fas fa-truck',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: false,
        acessoAcaiAmazonas: true,
        acessoPropex: false,
        acessos: acessosColeta
      },
      {
        nome: 'Notas Fiscais',
        path: '/notas-fiscais',
        icone: 'far fa-copy',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: acessosNotaFiscal
      },
      {
        nome: 'Metas',
        icone: 'fa fa-bullseye',
        subItens: [
          {
            nome: 'Metas',
            path: '/metas',
            icone: 'fa fa-bullseye',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosMeta
          },
          {
            nome: 'Representantes',
            path: '/metas-representantes',
            icone: 'fa fa-bullseye',
            acessoNutrata: true,
            acessoAgroplas: false,
            acessoRafitecGrass: false,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoRestrito: 'podeEditarMetas',
            acessos: acessosMeta
          }
        ],
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true
      },

      {
        nome: 'Cadastros',
        icone: 'fas fa-edit',
        subItens: [
          {
            nome: 'Regiões',
            path: '/cadastros/regioes',
            icone: 'fa fa-globe',
            acessoNutrata: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessos: acessosRegiao
          },
          {
            nome: 'Representantes',
            path: '/cadastros/representantes',
            icone: 'fas fa-suitcase',
            acessoNutrata: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessos: acessosRepresentante
          },
          {
            nome: 'Tabelas de Preços',
            path: '/cadastros/tabelas-precos',
            icone: 'fas fa-dollar-sign',
            acessoNutrata: true,
            acessoRafitec: false,
            acessoAcaiAmazonas: true,
            acessoPropex: false,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRestrito: 'acessoTabelasPrecos',
            acessos: acessosListagemTabelaPreco
          },
          {
            nome: 'Transportadoras',
            path: '/cadastros/transportadoras',
            icone: 'fas fa-truck',
            acessoNutrata: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessos: acessosTransportadora
          }
        ],
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true
      },

      {
        nome: 'Consultas',
        icone: 'fas fa-search',
        subItens: [
          {
            nome: 'Adimplência',
            path: '/consultas/adimplencia',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosTituloReceberAdimplenciaConsulta
          },
          {
            nome: 'Análise Financeira',
            path: '/consultas/analise-financeira',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosAnaliseFinanceira
          },
          {
            nome: 'Análise de Representante',
            path: '/consultas/analise-representante',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: false,
            acessoAcaiAmazonas: true,
            acessoPropex: false,
            acessos: acessosAnaliseRepresentante
          },
          {
            nome: 'Bonificações',
            path: '/consultas/bonificacoes',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: false,
            acessoAcaiAmazonas: true,
            acessoPropex: false,
            acessos: acessosBonificacao
          },
          {
            nome: 'Bonificações por Cliente',
            path: '/consultas/bonificacoes-clientes',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: false,
            acessoAcaiAmazonas: true,
            acessoPropex: false,
            acessos: acessosBonificacaoCliente
          },
          {
            nome: 'Cotações Status',
            path: '/consultas/cotacoes-status',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: false,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessos: acessosCotacaoStatus
          },
          {
            nome: 'Cotações Perdidas',
            path: '/consultas/cotacoes-perdidas',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: false,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessos: acessosCotacaoPerdida
          },
          {
            nome: 'Cotações Perdidas por Itens',
            path: '/consultas/cotacoes-perdidas-itens',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: false,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessos: acessosCotacaoPerdidaItem
          },
          {
            nome: 'Cotações Prazos Entregas',
            path: '/consultas/cotacoes-prazos-entregas',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: false,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessos: acessosCotacaoPrazoEntrega
          },
          {
            nome: 'Curva ABC de Vendas',
            path: '/consultas/curva-abc-vendas',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosCurvaAbcVenda
          },
          {
            nome: 'Efetividade de Vendas',
            path: '/consultas/efetividade-vendas',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosEfetividadeVenda
          },
          {
            nome: 'Metas',
            path: '/consultas/rafitec/metas',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: false,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessos: acessosRafitecMeta
          },
          {
            nome: 'Metas de Faturamento',
            path: '/consultas/metas-faturamento',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosMetaFaturamento
          },
          {
            nome: 'Minha Região',
            path: '/consultas/minha-regiao',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosMinhaRegiao
          },
          {
            nome: 'Pedido Resultado Líquido',
            path: '/consultas/pedido-resultado-liquido',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosPedidoResultadoLiquido
          },
          {
            nome: 'Pedidos GEPs',
            path: '/consultas/pedidos-geps',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosPedidoGep
          },
          {
            nome: 'Pedidos Status',
            path: '/consultas/pedidos-status',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosPedidoStatus
          },
          {
            nome: 'Títulos',
            path: '/titulos',
            icone: 'fas fa-search',
            acessoNutrata: true,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: true,
            acessoPropex: true,
            acessos: acessosTituloReceber
          },
          {
            nome: 'Comissões',
            path: '/comissoes',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: true,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessoRestrito: 'acessoComissoes',
            acessos: acessosComissao
          },
          {
            nome: 'Carteira de Pedidos',
            path: '/carteira-pedidos',
            icone: 'fas fa-search',
            acessoNutrata: false,
            acessoAgroplas: false,
            acessoRafitecGrass: true,
            acessoRafitec: true,
            acessoAcaiAmazonas: false,
            acessoPropex: true,
            acessos: acessosCarteiraPedido
          }
        ],
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true
      },
      {
        nome: 'Relatórios',
        icone: 'far fa-file-pdf',
        path: '/relatorios',
        acessoNutrata: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessos: acessosRelatorios
      },
      {
        nome: 'Configurações',
        path: '/configuracoes',
        icone: 'fa fa-cogs',
        acessoNutrata: true,
        acessoRafitec: true,
        acessoAcaiAmazonas: true,
        acessoPropex: true,
        acessoAgroplas: true,
        acessoRafitecGrass: true,
        acessos: usuarioPerfis
      }
    ];
  }

  mapRecursosToMenuItems(recursos: Recurso[]): ISidebarMenuItem[] {
    return recursos.map((recurso) => {
      const menuItem: ISidebarMenuItem = {
        icon: recurso.icone,
        label: recurso.nome,
        path: recurso.path,
        rotasAtivas: recurso.rotasAtivas,
        acessoRestrito: recurso.acessoRestrito,
        acessos: recurso.acessos || null,
        acessoNutrata: recurso.acessoNutrata,
        acessoRafitec: recurso.acessoRafitec,
        acessoAcaiAmazonas: recurso.acessoAcaiAmazonas,
        acessoPropex: recurso.acessoPropex,
        acessoAgroplas: recurso.acessoAgroplas,
        acessoRafitecGrass: recurso.acessoRafitecGrass
      };

      if (recurso.subItens?.length > 0) {
        menuItem.children = this.mapRecursosToMenuItems(recurso.subItens);
      }

      return menuItem;
    });
  }

  /** Obtem todos os recursos da aplicação que o perfil de usuário informado possuir acesso */
  getRecursos(): Promise<Recurso[]> {
    return new Promise<Recurso[]>((resolve) => {
      const usuario = this.authService.getUsuario();
      if (!usuario) {
        return [];
      }

      const recursosCopy = jQuery.extend(true, [], this.recursos); // Realizando uma cópia do array "original" dos recursos do sistema para garantir que o mesmo não seja sobreescrito no momento de obter os acessos permitidos para o usuário
      const recursos = this.getAcessosPermitidos(usuario, recursosCopy);
      resolve(recursos);
    });
  }

  /** Obtem os recrusos que o perfil informado tem acesso permitido no sistema */
  private getAcessosPermitidos(
    usuario: Usuario,
    recursos: Recurso[]
  ): Recurso[] {
    const recursosAcessoPermitido: Recurso[] = [];
    recursos.forEach((recurso) => {
      // Se for um grupo de recursos, verificamos se o perfil tem acesso em pelo menos um sub-recurso desse grupo
      if (recurso.subItens?.length > 0) {
        const recursosAcessosGrupo = this.getAcessosPermitidos(
          usuario,
          recurso.subItens
        );
        // Se tiver pelo menos um sub-recurso com acesso permitido, adicionamos o grupo com os seus sub-recursos permitidos
        if (recursosAcessosGrupo.length > 0) {
          recurso.subItens = recursosAcessosGrupo;
          recursosAcessoPermitido.push(recurso);
        }
      } else {
        if (recurso.acessos) {
          /* Se o perfil estiver incluso na lista de perfis que tem acesso ao recurso então
           * adicionamos esse recurso aos acessos permitidos */
          if (this.possuiAcesso(usuario, recurso)) {
            recursosAcessoPermitido.push(recurso);
          }
        }
      }
    });
    return recursosAcessoPermitido;
  }

  /** Verifica se a empresa possui ou não acesso ao recurso informado */
  private possuiAcessoEmpresa(recurso: Recurso): boolean {
    if (!recurso) {
      return false;
    }

    // Nutrata
    if (this.authService.isNutrata() && recurso.acessoNutrata) {
      return true;
    }
    // Rafitec
    if (this.authService.isRafitec() && recurso.acessoRafitec) {
      return true;
    }
    // Açaí Amazonas
    if (this.authService.isAcaiAmazonas() && recurso.acessoAcaiAmazonas) {
      return true;
    }
    // Propex
    if (this.authService.isPropex() && recurso.acessoPropex) {
      return true;
    }
    // Agroplás
    if (this.authService.isAgroplas() && recurso.acessoAgroplas) {
      return true;
    }
    // Rafitec Grass
    if (this.authService.isRafitecGrass() && recurso.acessoRafitecGrass) {
      return true;
    }

    return false;
  }

  /** Verifica se o perfil possui acesso ao recurso informado */
  private possuiAcesso(usuario: Usuario, recurso: Recurso): boolean {
    if (!usuario || !usuario.perfil || !recurso || !recurso.acessos) {
      return false;
    }

    // Empresa => Verifica se a empresa possui ou não acesso ao recurso
    if (!this.possuiAcessoEmpresa(recurso)) {
      return false;
    }

    // Acesso Restrito => Se o recurso possuir acesso restrito e o usuário não possuir permissão de acesso a este recurso
    if (!this.possuiPermissaoRestrita(usuario, recurso.acessoRestrito)) {
      return false;
    }

    // Perfil do Usuário => Se o acesso procurado for diferente de null, então esse perfil possui acesso ao menu
    const acesso = recurso.acessos.find(
      (acessoFiltro) => acessoFiltro.id === usuario.perfil
    );
    return acesso != null;
  }

  /**
   * Resolve o acesso restrito do recurso. Uma lista de permissões é satisfeita por
   * qualquer uma delas, como exige a governança do PLM, onde quem decide alcança a
   * fila sem depender da permissão de acompanhamento.
   */
  private possuiPermissaoRestrita(
    usuario: Usuario,
    acessoRestrito?: string | string[]
  ): boolean {
    if (!acessoRestrito) {
      return true;
    }

    const permissoes = Array.isArray(acessoRestrito)
      ? acessoRestrito
      : [acessoRestrito];
    return permissoes.some((permissao) => !!usuario[permissao]);
  }
}
